/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2 } from '@insticator/insticator-ui';

/* ++++++++++ --------------- MODAL GENERAL PAGE - TRENDING CONFIGS : STYLES --------------- ++++++++++ */
export default {
    modal: {
        position: 'absolute',
        top: '235px',
        left: '445px',
        background: themeV2.color.base.white,
        borderRadius: '10px',
        boxShadow: '0px 4px 12px 0px rgba(48, 48, 48, 0.2)',
        width: '369px',
        padding: '14px',
        zIndex: '1000',
        '& .content': {
            color: themeV2.color.primary.main,
            fontSize: '16px',
            fontWeight: 'normal',
            textAlign: 'center',
            letterSpacing: '0px',
            lineHeight: '22px',
        },
        '& button': {
            marginTop: '16px',
            marginLeft: '60px',
        }
    }
};
